import { createSlice } from "@reduxjs/toolkit";
import {
  GetDrivePrefrenceAction,
  GetProfileAction,
  ManageDrivePrefrenceAction,
  UpdateProfileAction,
} from "store/middlewares/profile";

export const profileSlice = createSlice({
  name: "profile",
  initialState: {
    profile: null,
    drivePrefrences: null,
    profileLoading: false,
  },
  reducers: {
    updateProfile: (state, action) => {
      const { id } = action.payload;
      if (id === state.profile?.id) {
        state.profile = { ...state.profile, ...action.payload };
      }
    },
    updateDrivePrefrence: (state, action) => { 
      state.drivePrefrences = { ...state.drivePrefrences, ...action.payload };
    }
  },
  extraReducers(builder) {
    builder
      .addCase(GetProfileAction.fulfilled, (state, action) => {
        state.profile = action.payload.response;
      })
      .addCase(GetDrivePrefrenceAction.fulfilled, (state, action) => {
        state.drivePrefrences = action.payload.response;
      })
      .addCase(ManageDrivePrefrenceAction.fulfilled, (state, action) => {
        state.drivePrefrences = action.payload.response;
      })


      .addCase(UpdateProfileAction.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.profile = { ...state.profile, ...action.payload.response };
      })
  },
});

export const { updateProfile ,updateDrivePrefrence} = profileSlice.actions;

export default profileSlice.reducer;
